<template>
    <div>
        <form-group type="text"
                    label="First Name"
                    id="first_name"
                    v-model="form.first_name"
                    :error="form.errors.get('first_name')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    label="Last Name"
                    id="last_name"
                    v-model="form.last_name"
                    :error="form.errors.get('last_name')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="text"
                    label="Username"
                    id="username"
                    v-model="form.username"
                    :error="form.errors.get('username')"
                    @event="form.listen(form, $event)">
        </form-group>

        <form-group type="select"
                    :options="[
                        {name: 'Admin', value: 'Admin'},
                        {name: 'User', value: 'User'},
                    ]"
                    option_name="name"
                    option_value="value"
                    label="Role"
                    id="role"
                    v-model="form.role"
                    :error="form.errors.get('role')"
                    @event="form.listen(form, $event)">
        </form-group>

        <a v-if="!create" @click="toggleSetPassword()">
            {{ setPassword ? 'Don\'t change password' : 'Change Password' }}
        </a>
        <span v-if="setPassword || create">
            <form-group type="text"
                        label="Password"
                        id="password"
                        v-model="form.password"
                        :error="form.errors.get('password')"
                        @event="form.listen(form, $event)">
            </form-group>

            <form-group type="text"
                        label="Confirm Password"
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        :error="form.errors.get('password_confirmation')"
                        @event="form.listen(form, $event)">
            </form-group>
        </span>
        <div class="has-text-centered">
            <button type="button" class="button is-primary" @click="submit()">{{ create ? 'Create Admin' : 'Save Changes' }}</button>
        </div>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {CREATE_ADMIN, UPDATE_ADMIN} from "../../store/mutation-types"
    export default {
        props: {
            admin: {
                type: [String, Object], default: () => {
                    return {
                        first_name: '',
                        last_name: '',
                        username: '',
                        password: '',
                        role: '',
                    }
                }
            },
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                setPassword: false,
                form: new Form(this, Object.assign({}, this.admin, {
                    password: null,
                    password_confirmation: null,
                }), this.create ? CREATE_ADMIN : UPDATE_ADMIN)
            }
        },
        methods: {
            submit() {
                this.form.submit().then(data => {
                    this.$emit('saved', data)
                })
            },
            toggleSetPassword() {
                this.setPassword = !this.setPassword
                if (!this.setPassword) {
                    this.form.password              = null
                    this.form.password_confirmation = null
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// AdminForm.vue?eb47e00a